import { Items, PickerItem } from '../../../hqo-wheel-picker/interfaces';

const PINNED_TYPE_FILTER_IDS = [0, 1]; // Ids of UNLISTED and UNSPECIFIED filters in database

/**
 * Pinned options first, the rest alphabetised FOR THE READER.
 *
 * `label.localeCompare(other)` with no locale collates in the runtime's locale, so the order was
 * whatever the serving machine happened to use. Slovak treats `ch` as a single letter sorting after
 * `h`, so Chlieb belongs after Cukor; Polish sorts Ć after C. Building the collator once also avoids
 * re-deriving the collation rules on every comparison.
 */
export const sortOptionsForLocale = (options: Items | undefined, locale: string): Items => {
  if (!options || !Array.isArray(options)) {
    return [];
  }

  const collator = new Intl.Collator(locale);
  const pinned: PickerItem[] = [];
  const unpinned: PickerItem[] = [];

  options.forEach(option => {
    const numericValue = option?.value != null ? Number(option.value) : NaN;

    if (!isNaN(numericValue) && PINNED_TYPE_FILTER_IDS.includes(numericValue)) {
      pinned.push(option);
    } else {
      unpinned.push(option);
    }
  });

  // A PickerItem label is typed ReactNode, and the component coerces it with toLocaleString() before
  // rendering, so coerce the same way here rather than assuming a string.
  const text = (item: PickerItem): string => String(item.label ?? '');

  return [...pinned, ...unpinned.sort((a, b) => collator.compare(text(a), text(b)))];
};
